import React, { useState, useRef, useEffect } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from "react-router-dom";
import { contact, getFlags} from '../../routes/UserAction';
import axios from "axios";


import { domainUrl } from '../../data/dummyData';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
// import './contact.css'

export default function Contact() {
    const dispatch = useDispatch();
    const {
        loading,
        user,
        error,
        success,
        successMessage,
    } = useSelector((state) => state.user || {});
    const userData = user;

    const [flags, setFlags] = useState([]);
    const fetchFlags = () => {
        dispatch(getFlags())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setFlags(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        fetchFlags();
    }, [])


    const [errorMsg, setErrorMsg] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const [email, setEmail] = useState(userData?.email? userData?.email:'');
    const [msg, setMsg] = useState('');
    const [name, setName] = useState(userData?.email? userData?.first_name+' '+userData?.last_name :'');
    const [title, setTitle] = useState('');
    const [sendSMS, setSendSMS] = useState(false);

    const [location, setLocation] = useState(null);


    const detectInputType = (value) => {
        const intlPhoneRegex = /^\+\d{10,15}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
        if (/^\d{10,15}$/.test(value)) {
            alert("Please enter phone numbers in international format, e.g., +233559148214");
            return 'invalidPhone';
        }
    
        if (intlPhoneRegex.test(value)) return 1; // phone
        if (emailRegex.test(value)) return 2;     // email
        return 'invalid';
    };
    
    const sanitizePhone = (value) => value.startsWith('+') ? value.slice(1) : value;

    const handleSubmit = () => {
        setSubmitting(true);
    
        if ((!email) || (!title) || (!msg) || (!name) ) {
            alert("Form filled incorrectly!");
            return;
        }
        
        dispatch(contact({
            email: sendSMS? userData?.phone: userData?.email,
            isPhone: sendSMS? 1: 2, // phone =1, email =2
            lat: location?.lat,
            long: location?.long,
            msg,
            title,
            name,
        }))
        .then((response) => {
            // if (!response?.success) {
            //     // console.log('Contact error:', response?.message);
            //     alert(error);
            // } else {

            //     // console.log('response', response)
            //     // navigate('/');
            // }

            setMsg('');
            setTitle('');
        })
        .catch((error) => {
            console.log('Dispatch error:', error);
        })
        .finally(() => {
            setSubmitting(false);
        });
    };

    const handleSend = async () => {
        setSubmitting(true);
    
        if ((!email) || (!title) || (!msg) || (!name) ) {
            alert("Form filled incorrectly!");
            return;
        }

        const inputType = detectInputType(email);
    
        
        if (inputType === 'invalidPhone') {
            alert("Phone number must start with '+' and be in international format.");
            return;
        }

        if (inputType === 'invalid') {
            alert("Please enter valid phone number or email");
            return;
        }
    
        const processedEmail = inputType === 1 ? sanitizePhone(email) : email;
        
        try {
            const { data } = await axios.post(`${domainUrl}/emy_contact_us`, { 
                email: processedEmail,
                isPhone: inputType, // phone =1, email =2
                lat: location?.lat,
                long: location?.long,
                msg,
                title,
                name,
            });
      
            if (data.success) {
                setMsg('');
                setTitle('');
                alert(data.message);
            } else {
              alert(data.message);
            }
        } catch (err) {
            if (err.response) {
                alert("Error: " + JSON.stringify(err.response.data.message || err.response.data));
            } else if (err.request) {
                alert("Error: No response received from server" );
            } else {
                alert("Error: Error setting up request" );
            }
        }
    };

    return (
        // loading ? (
        //   <div className="loader-container">
        //       <div className="spinner"></div>
        //       {/* <h6 style={{color: 'white', textAlign:'center'}}>loading please wait...</h6> */}
        //   </div>
        // ) :
        <>
        <Header page={'contact'}/>

            
        {/* <!-- Contact Start --> */}
        <div className="container-fluid contact py-5">
            <div className="container py-5">
                <div className="row g-5">
                    <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.2s">
                        <div className="mb-4">
                            <h4 className="text-success">Contact Us</h4>
                            <h1 className="display-4 mb-4 text-danger">Welcome To MJ-Emylab...</h1>
                            <p className="mb-4">
                                {
                                    flags?.find(el => el.name === 'emy_about1' && el.type === 1)?.value ||
                                    ""
                                }
                            </p>
                            <div className="row g-4">
                                <div className="col-lg-6">
                                <div className="bg-white d-flex">
                                    <i className="fas fa-map-marker-alt fa-2x text-success me-2"></i>
                                    <div>
                                    <h4>Head Office</h4>
                                    <p className="mb-0">
                                        {flags?.find(el => el.name === 'emy_headoffice' && el.type === 1)?.value || 'Accra, Ghana'}
                                    </p>
                                    </div>
                                </div>
                                </div>

                                <div className="col-lg-6">
                                <div className="bg-white d-flex">
                                    <i className="fas fa-envelope fa-2x text-success me-2"></i>
                                    <div>
                                    <h4>Mail Us</h4>
                                    <p className="mb-0">
                                        {flags?.find(el => el.name === 'emy_email' && el.type === 1)?.value || 'info@mj-emylab.com'}
                                    </p>
                                    </div>
                                </div>
                                </div>

                                <div className="col-lg-6">
                                <div className="bg-white d-flex">
                                    <i className="fa fa-phone-alt fa-2x text-success me-2"></i>
                                    <div>
                                    <h4>Telephone</h4>
                                    <p className="mb-0">
                                        {flags?.find(el => el.name === 'emy_phone' && el.type === 1)?.value || '(+233) 559 148 214'}
                                    </p>
                                    </div>
                                </div>
                                </div>

                                <div className="col-lg-6">
                                <div className="bg-white d-flex">
                                    <i className="fa fa-clock fa-2x text-success me-2"></i>
                                    <div>
                                    <h4>Working Hours</h4>
                                    <p className="mb-0">
                                        {flags?.find(el => el.name === 'emy_hours' && el.type === 1)?.value || '8:00 am - 10:00 pm'}
                                    </p>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex ms-2 mb-5">
                            <a
                                className="btn btn-primary py-2 px-3 px-sm-4 me-2"
                                href={flags?.find(el => el.name === 'emy_facebook' && el.type === 1)?.value || "https://www.facebook.com/profile.php?id=61575002202692"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span>Facebook</span> <i className="fas fa-chevron-circle-right"></i>
                            </a>
                            
                            <a
                                className="btn btn-primary py-2 px-3 px-sm-4 mx-2"
                                href={flags?.find(el => el.name === 'emy_x' && el.type === 1)?.value || "https://x.com/mj_emylab"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span>X</span> <i className="fas fa-chevron-circle-right"></i>
                            </a>

                            <a
                                className="btn btn-primary py-2 px-3 px-sm-4 ms-2"
                                href={flags?.find(el => el.name === 'emy_tiktok' && el.type === 1)?.value || "https://www.tiktok.com/@mj_emylab"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span>TikTok</span> <i className="fas fa-chevron-circle-right"></i>
                            </a>
                        </div>
                        <div className="contact-banner">
                            <div className="row g-0">
                                <div className="col-9">
                                    <div className="p-4 pe-0">
                                        <h4 className="display-5 mb-0">Follow our activities</h4>
                                        <div className="d-flex align-items-center">
                                            <a href="index.html" className="h5 mb-0 me-3">visit our channel</a>
                                            <a
                                                className="text-primary py-3"
                                                href={flags?.find(el => el.name === 'emy_youtube' && el.type === 1)?.value || "https://www.youtube.com/"}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fas fa-play-circle me-2"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.4s">
                        <div className="form-section bg-success p-5 h-100">
                            <h1 className="display-4 text-white mb-4">Get In touch</h1>

                            {userData && (userData?.first_name !== '' || userData?.first_name !== null)?    
                                <form>
                                    <div className="row g-4">
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-floating form-section-col">
                                                <input value={name} readOnly type="text" className="form-control border-0" id="name" placeholder="Your Name"/>
                                                <label for="name">Your Name</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-floating form-section-col">
                                                <input value={email} readOnly type="email" className="form-control border-0" id="email" placeholder="Your Email"/>
                                                <label for="email">Your Email</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-floating form-section-col">
                                                <input value={title} onChange={(e) => setTitle(e.target.value)} type="text" className="form-control border-0" id="subject" placeholder="Subject"/>
                                                <label for="subject">Subject</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-floating">
                                                <textarea onChange={(e) => setMsg(e.target.value)} value={msg} className="form-control border-0" placeholder="Leave a message here" id="message" style={{height: '160px'}}></textarea>
                                                <label for="message">Message</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-check">
                                                <input onChange={(e) => setSendSMS(e.target.checked)} className="form-check-input" type="checkbox" value="#" id="flexCheck"/>
                                                <label className="form-check-label text-white" htmlFor="flexCheck">{sendSMS ? "Send SMS" : "Send Email"}</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-section-col">
                                                <button type="button" onClick={handleSubmit} className="btn-primary w-100 py-3 px-5">Send Message</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            : <>
                                <form>
                                    <div className="row g-4">
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-floating form-section-col">
                                                <input value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control border-0" id="name" placeholder="Your Name"/>
                                                <label for="name">Your Name</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-xl-6">
                                            <div className="form-floating form-section-col">
                                                <input value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="form-control border-0" id="email" placeholder="Email/Phone"/>
                                                <label for="email">Your Email/Phone</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-floating form-section-col">
                                                <input value={title} onChange={(e) => setTitle(e.target.value)} type="text" className="form-control border-0" id="subject" placeholder="Subject"/>
                                                <label for="subject">Subject</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-floating">
                                                <textarea value={msg} onChange={(e) => setMsg(e.target.value)} className="form-control border-0" placeholder="Leave a message here" id="message" style={{height: '160px'}}></textarea>
                                                <label for="message">Message</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-section-col">
                                                <button type="button" onClick={handleSend} className="btn-primary w-100 py-3 px-5">Send Message</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                </>
                            }

                            
                        </div>
                    </div>

                    {/* map */}
                    <div className="col-12 wow fadeInUp" data-wow-delay="0.2s">
                        <div className="h-100 overflow-hidden">
                            <iframe className="w-100" style={{height: '400px'}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1694259649153!5m2!1sen!2sbd" 
                            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>

                    {/* <div className="col-12 wow fadeInUp" data-wow-delay="0.2s">
                        <div className="h-100 overflow-hidden">
                            <iframe
                            className="w-100"
                            style={{ height: '400px' }}
                            src={`https://www.google.com/maps/embed/v1/view?key=YOUR_GOOGLE_MAPS_API_KEY&center=${
                                flags?.find(el => el.name === 'emy_lat' && el.type === 1)?.value || '40.6974881'
                            },${
                                flags?.find(el => el.name === 'emy_long' && el.type === 1)?.value || '-73.979681'
                            }&zoom=12`}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            allowFullScreen
                            ></iframe>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
        {/* <!-- Contact End --> */}

        <Footer/>
        </>
    );
}
